import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import QuizRequests from "../../../../assets/services/quiz";
import {
  setCurrentQuestion,
  setRightAnswer,
  setWrongAnswers,
} from "../../../../assets/redux/actions/Quiz";
import TestQuestion from "./testQuestion";
import AnimatedPageContainer from "../../../../assets/containers/AnimatedPageContainer";
import SubmitButtonContainer from "./SubmitButtonContainer";
import TestImageQuestion from "./testImageQuestion";
import RangeQuestion from "./RangeQuestion";
import OrderQuestion from "./OrderQuesiton";
import DifferenceQuestion from "./DifferenceQuestion";
import PuzzleQuestion from "./PuzzleQuestion";
import ConnectQuestion from "./ConnectQuestion";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import QuestionsStatus from "../QuestionsStatus";
import FinalizeMatchAlert from "../../alertContents/FinalizeMatchAlert";
import MatchLoadingOverlay from "../../LoadingOverlay";
import AnswerQuestion from "../../alertContents/AnswerQuestion";
import UploadFileQuestion from "./UploadFile";
import CheatModal from "../../alertContents/CheatDialog";

function QuestionContainer() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const query = queryParams.get("type");
  const mId = queryParams.get("qId");
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { currentQuestion, finalize, loadingQuizReq } = useSelector(
    ({ quiz }) => quiz
  );

  useEffect(() => {
    if (!finalize) {
      dispatch(QuizRequests.getQuestionByID(id));
      dispatch(setWrongAnswers(null));
      dispatch(setRightAnswer(null));
    }
    return () => {
      dispatch(setCurrentQuestion(null));
    };
  }, [id]);

  useEffect(() => {
    if (finalize) {
      dispatch(QuizRequests.finalizeAndGetReport(mId));
      navigate(-2, { replace: true });
    }
  }, [dispatch, finalize]);

  useEffect(() => {
    if (currentQuestion && !finalize) {
      QuizRequests.setLastQuestion(
        localStorage.getItem("Ticket"),
        currentQuestion._id
      );
    }
  }, [currentQuestion, finalize]);

  let quiz = <TestQuestion />;

  if (query === "تصویری") {
    quiz = <TestImageQuestion />;
  } else if (query === "مرتب کردن") {
    quiz = <OrderQuestion />;
  } else if (query === "طیفی") {
    quiz = <RangeQuestion />;
  } else if (query === "کشف تفاوت") {
    quiz = <DifferenceQuestion />;
  } else if (query === "پازل") {
    quiz = <PuzzleQuestion />;
  } else if (query === "وصل کردن") {
    quiz = <ConnectQuestion />;
  } else if (query === "ارسال فایل") {
    quiz = <UploadFileQuestion />;
  }

  return (
    <>
      <AnimatedPageContainer>
        <div className="customContainer">
          <QuestionsStatus
            progressColor={"var(--warningColor)"}
            matchId={mId}
          />
          {quiz}
        </div>
        <SubmitButtonContainer matchId={mId} />
        <AnswerQuestion />
        <CheatModal />
        <FinalizeMatchAlert />
      </AnimatedPageContainer>
      <MatchLoadingOverlay isActive={loadingQuizReq} />
    </>
  );
}

export default QuestionContainer;
